<template>
  <div>
    <!-- -->
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {}
  },
  mounted () {
    this.scanLogin()
  },
  methods: {
    // | 扫码登录
    async scanLogin () {
      const { type, qrRecordId, code } = this.$route.query
      if (type !== 'scan' || !qrRecordId) {
        return
      }
      if (this.$store.getters.isLogin) {
        this.$tkParse.put(`/classes/qrCodeRecord/${qrRecordId}`, {
          status: '成功',
          user: this.$store.state.user.objectId
        })
        await this.$tkHelper.sleep(500)
        // eslint-disable-next-line no-undef
        wx.closeWindow()
        return
      }
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let { data: res } = await this.$tkParse.post('/wxlogin', { code })
      if (!res || (res && !res.status) || res.status !== 'success') {
        Toast.fail('保存失败')
        Toast.clear()
        // eslint-disable-next-line no-throw-literal
        throw res.message || '登录失败'
      }
      if (res.status === 'success') {
        this.$store.commit('setSessionToken', res.data.sessionToken)
        this.$store.commit('setUser', res.data.user)
        this.$tkParse.put(`/classes/qrCodeRecord/${qrRecordId}`, {
          status: '成功',
          user: res.data.user.objectId
        })
        await this.$tkHelper.sleep(500)
        // eslint-disable-next-line no-undef
        wx.closeWindow()
      }
      Toast.clear()
    }
  }
}
</script>
